import { SessionStorage } from "./sessionStorage";

export type TToysAvailabilityStorageValue = {
	privateShowId: string;
	isAvailable: boolean;
	isProposalPending?: boolean;
};

class ToysAvailabilityStorage extends SessionStorage {
	public constructor() {
		super({
			storageKey: "toys_availability",
		});
	}
}

export const toysAvailabilityStorage = new ToysAvailabilityStorage();
